module.exports = __webpack_public_path__ + "static/media/buddy.403cb9f6.svg";